<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
    :disabled="disabled"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="stringDate"
        :label="label"
        prepend-icon="event"
        readonly
        v-on="on"
        hide-details
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      @input="menu = false"
      :min="minDate"
      no-title
      :disabled="disabled"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { DateTime } from "luxon";

export default {
  name: "InputDate",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Date],
      required: false,
      default: "",
    },
    minDate: {
      type: String,
      required: false,
    },
    returnObject: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      menu: null,
    };
  },
  computed: {
    stringDate: {
      get() {
        if (this.value.includes("T")) {
          return DateTime.fromISO(this.value).toLocaleString(DateTime.DATETIME_SHORT);
        }
        return this.value;
      },
    },
    date: {
      get() {
        if (this.returnObject && this.value instanceof Date && this.value != null) {
          return this.value.toISOString().split("T")[0];
        }

        return this.value;
      },
      set(val) {
        if (this.returnObject) {
          this.$emit("input", new Date(val));
          return;
        }
        if (this.value.includes("T")) {
          this.$emit("input", DateTime.fromISO(val).toISO({ includeOffset: false }));
          return;
        }
        this.$emit("input", val);
      },
    },
  },
};
</script>
